import { render, staticRenderFns } from "./InventoryDuplicate.vue?vue&type=template&id=9229fea0"
import script from "./InventoryDuplicate.vue?vue&type=script&lang=js"
export * from "./InventoryDuplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports